// allowed to client and server.
// Public, client-safe env accessors. Use only NEXT_PUBLIC_* keys here.

export const myPublicEnvs = {
    // NEXT_PUBLIC_RAZORPAY_KEY_ID: process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID!,
    // NEXT_PUBLIC_PROJECT_SITE_URL: process.env.NEXT_PUBLIC_PROJECT_SITE_URL!,
    // NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY!,
    NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
        process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN!,
    NEXT_PUBLIC_FIREBASE_PROJECT_ID:
        process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID!,
    NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET:
        process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET!,
    NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
        process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID!,
    NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID!,
} as const;

// Generic validation: throw listing the exact missing/empty keys (without enumerating schemas per key)
const invalid = Object.entries(myPublicEnvs)
    .filter(([, v]) => typeof v !== "string" || v.length === 0)
    .map(([k]) => k);

if (invalid.length > 0) {
    throw new Error(
        `Missing or empty public env(s): ${invalid.join(
            ", "
        )}. Add them to .env.local and restart the server.`
    );
}
